import script from "./AddressField.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressField.vue?vue&type=script&lang=ts&setup=true"

import "./AddressField.vue?vue&type=style&index=0&id=9094935a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9094935a"]])

export default __exports__